
import React from 'react';
import { observer } from 'mobx-react-lite';
import { capitalize } from 'lodash';

import { IntegrationLocation, Platform } from '@vromo/models/integrations';
import Switch from '@vromo/ui/components/Switch';
import { useParams } from 'react-router';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { useIntegrationLocations, useIntegrationsPage } from '../hooks';





type LocationRowProps = {
    /** allow to edit "enable" field, if this flag is true */
    edit?: boolean
    location: IntegrationLocation
}



/** Render details of a configured platform integration location  */
export const LocationRow = observer<LocationRowProps>(({ edit, location }) => {

    const { queryLocations } = useIntegrationLocations()
    const { isLoading } = useIntegrationsPage()
    const { platform } = useParams<{ platform: Platform }>()

    return (
        <tr title={location.enabled ?
            location.ext_active ?
                "Orders from this location will be ingested" :
                `Orders from this location will be ignored becuse location is disabled on platform source`
            :
            "Orders from this location will be ignored"
        }>
            <td style={{ textAlign: 'center' }}>

                {edit ?
                    <Switch
                        checked={location.enabled}
                        disabled={!location.ext_active || isLoading || !edit}
                        onChange={() => queryLocations(platform, location.enabled ? "disable" : "enable", location.ext_site_id)}
                        style={{ margin: 'auto' }}
                    />
                    :
                    <FontAwesome icon={
                        location.enabled ?
                            !location.ext_active ?
                                "exclamation-triangle" :
                                "fa-solid fa-check"
                            : "times"} />
                }
            </td>
            <td >{capitalize(location.ext_title)}</td>
            <td >{location.ext_site_id}</td>
            <td>
                {
                    location.ext_active ?
                        "Active" :
                        "Inactive"
                }
            </td>
        </tr >
    );
});
